export const CLAIMS_ROLLING_MONTHS = 'CLAIMS_ROLLING_MONTHS';
export const CLAIMS_MONTHLY_DATA = 'CLAIMS_MONTHLY_DATA';
export const CREATE_FEEDBACK = 'CREATE_FEEDBACK';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';
export const RESET_CLAIMS_DATA = 'RESET_CLAIMS_DATA';
